import "../styles.css"
export const News=()=>{
    return (
        <div className="news-main">
            <h2 className="news-h2">In the News</h2>
            <div className="news-div">
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/35/inthenews_62aadde78bdae" alt="" />
                    <h4 className="news-head">Licious Is India's First Animal Protein Bran...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/36/inthenews_62aadf6e2cbb7" alt="" />
                    <h4 className="news-head">Licious announces continuous liquidity...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/37/inthenews_62aae0b741820" alt="" />
                    <h4 className="news-head">Why Licious wants to become the..,</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/38/inthenews_62aae10540001" alt="" />
                    <h4 className="news-head">India's Licious becomes unicorn wit...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/39/inthenews_62aae1c5de08e" alt="" />
                    <h4 className="news-head">They slayed COVID, went on to build a...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/40/inthenews_62aae21e9a38e" alt="" />
                    <h4 className="news-head">Licious founders on building a unicorn...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/40/inthenews_62aae21e9a38e" alt="" />
                    <h4 className="news-head">Licious founders on building a unicorn...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/42/inthenews_62aae2a6d9bc4" alt="" />
                    <h4 className="news-head">Licious wants you eat more meat...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/43/inthenews_62aae2dadd8aa" alt="" />
                    <h4 className="news-head">Licious pledges to be ESG compliant in the...</h4>
                </div>
                <div className="news-second">
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/44/inthenews_62aae32108c39" alt="" />
                    <h4 className="news-head">Online meat startup Licious unveils ads...</h4>
                </div>
                <div>
                    <img className="news-img" src="https://d2407na1z3fc0t.cloudfront.net/inTheNews/45/inthenews_62aae4c4d8331" alt="" />
                    <h4 className="news-head">Faster Chef Treats Uninvited Friends...</h4>
                </div>
            </div>
        </div>
    )
}